define(['components/utilities/utilities', 'libs/script'], function (utils, $script) {
	'use strict';

	/**
	 * Kolada integration
	 * A plugin that loads the Kolada script.
	 * @exports koladaIntegration
	 */
	var koladaIntegration = {

		/**
		 * The initialization function for this module.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		init: function (el) {
			var koladaUrl = el.getAttribute('data-url') || false;

			if (koladaUrl) {
				$script.get(koladaUrl, function () {});
			}
		}
	};


	return koladaIntegration;
});


//////////////////
// WEBPACK FOOTER
// ./components/kolada/kolada.js
// module id = 16
// module chunks = 2